<template>
  <TAlertDangerous
    :open="showConfirmation"
    :confirm-action-label="$t('course_settings.collaboration.remove_teacher')"
    :title="$t('course_settings.collaboration.remove_teacher')"
    :description="
      $t('course_settings.collaboration.remove_teacher_description', [
        {
          id: 'collaboratorName',
          value: collaborator.fullName,
        },
        {
          id: 'courseName',
          value: course.name,
        },
      ])
    "
    :confirm-action="removeCollaboratorConfirm"
    :cancel-action="removeCollaboratorCancel"
  />
  <TModalNormal :open="show" @close="closeModal">
    <TH1>{{ collaborator.fullName }}</TH1>
    <TP2>{{ $t('course_settings.collaboration.invite.description') }}</TP2>
    <template v-if="!loading">
      <CourseSettingsCollaborationRoleSelector v-model="selectedRole" />
      <TButtonFull class="mt-6" @click="saveNewRole()">{{ $t('generic_save') }}</TButtonFull>

      <hr class="b-2 my-6" />
      <TButtonFullDangerous class="" @click="removeCollaborator"
        >{{ $t('course_settings.collaboration.remove_teacher') }}
      </TButtonFullDangerous>
    </template>
    <template v-else>
      <TLoadingIndicatorBig />
    </template>
  </TModalNormal>
</template>
<script lang="ts" setup>
import type { Course, CourseCollaborator, CourseMembershipRole } from '~/graphql';
import { useUpdateCourseCollaboratorMutation } from '~/composables';
import toast from '~/components/Toast';

const { $t } = useNuxtApp();

const props = defineProps<{
  course: Course;
  collaborator: CourseCollaborator;
  show: boolean;
}>();

const emits = defineEmits(['close']);
const selectedRole = ref<CourseMembershipRole>(props.collaborator.courseRole);
const loading = ref(false);
const showConfirmation = ref(false);

function closeModal() {
  emits('close');
}

const updateCollaboratorMutation = useUpdateCourseCollaboratorMutation();

async function saveNewRole() {
  loading.value = true;
  const { error } = await updateCollaboratorMutation.executeMutation({
    updateCourseCollaboratorInput: {
      collaboratorId: props.collaborator.id,
      courseMembershipRole: selectedRole.value,
    },
  });
  if (error) {
    toast.error($t('generic_error'));
    loading.value = false;
  } else {
    toast.success($t('success'));
    loading.value = false;
    closeModal();
  }
}

const removeCollaboratorMutation = useRemoveCourseCollaboratorMutation();

function removeCollaborator() {
  showConfirmation.value = true;
}

function removeCollaboratorCancel() {
  showConfirmation.value = false;
}

async function removeCollaboratorConfirm() {
  loading.value = true;
  const { error } = await removeCollaboratorMutation.executeMutation({
    removeCourseCollaboratorInput: {
      collaboratorId: props.collaborator.id,
    },
  });
  if (error) {
    toast.error($t('generic_error'));
    loading.value = false;
  } else {
    toast.success($t('success'));
    loading.value = false;
    closeModal();
  }
}
</script>
